import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      {/* Top Stats Bar */}
      <div className="w-full px-4 md:px-8 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-black text-primary-400">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="w-full px-4 md:px-8 py-10 md:py-14 border-t border-background-800/50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-background-50 font-black text-sm">51</span>
              </div>
              <span className="text-lg font-bold text-foreground-100">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a
                href={siteInfo.url}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-fill" />
              </a>
              <span
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
                title={`微信号：${siteInfo.contact.wechat}`}
              >
                <i className="ri-wechat-fill" />
              </span>
              <a
                href={`mailto:${siteInfo.contact.email}`}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="邮箱"
              >
                <i className="ri-mail-fill" />
              </a>
            </div>
          </div>

          {/* Categories Column */}
          <div>
            <h4 className="text-sm font-bold text-foreground-200 mb-4 tracking-wide">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-foreground-200 mb-4 tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/daily-gossip"
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  每日黑料
                </Link>
              </li>
              <li>
                <Link
                  to="/category/exclusive-news"
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  独家猛料
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-sm font-bold text-foreground-200 mb-4 tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-foreground-600">
                  <i className="ri-mail-line text-sm" />
                </div>
                <a
                  href={`mailto:${siteInfo.contact.email}`}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors break-all"
                >
                  {siteInfo.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-foreground-600">
                  <i className="ri-wechat-line text-sm" />
                </div>
                <span className="text-sm text-foreground-500">
                  微信号：{siteInfo.contact.wechat}
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-foreground-600">
                  <i className="ri-map-pin-line text-sm" />
                </div>
                <span className="text-sm text-foreground-500">
                  {siteInfo.contact.address}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="w-full px-4 md:px-8 py-5 border-t border-background-800/50">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600 text-center sm:text-left">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/about"
              className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors"
            >
              关于我们
            </Link>
            <span className="text-foreground-700">|</span>
            <span className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
              隐私政策
            </span>
            <span className="text-foreground-700">|</span>
            <span className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">
              免责声明
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
